module.exports = __webpack_public_path__ + "static/media/watermark.e641b849.jpg";